<aside class="esf-main-sidebar esf-main-sidebar--working-space -has-transition -extra-width"
       [ngClass]="{'-is-open': tixxSelectOverviewService.listOfModals.editWebpageIndividualizationModalOpened}">
  <div class="esf-main-sidebar__content">
    <h3 i18n="Club logo upload heading@@clubComponent.heading.webpageIndividualization">Webpage Individualization</h3>
    <form [formGroup]="webpageIndividualizationForm" (ngSubmit)="submitForm()" id="webpageIndividualizationForm">
      <div class="esf-form-item">
        <label class="esf-form-item__label">
          <span i18n="Club logo upload heading@@clubComponent.heading.uploadHeroImage">Upload Hero Image</span>
          <app-optional></app-optional>
        </label>
        <label for="importData" id="importLogo" class="esf-button esf-button--standard esf-button--outlined esf-file-upload__button">
          <svg class="esf-icon esf-button__icon" width="16" height="16">
            <use xlink:href="#esf-icon-upload"></use>
          </svg>
          <span id="importFileLabel" class="esf-button__icon-text">
            <span *ngIf="fileToUpload !== null">{{ fileToUpload.name }}</span>
            <span *ngIf="fileToUpload === null" i18n="Club logo upload - select a file@@clubComponent.formLabel.selectFile">Select a file</span>
          </span>
        </label>
        <input class="esf-form-item__field esf-file-upload__input" type="file" id="importData" (change)="fileChange($event.target)">
      </div>
      <div app-form-field-text-generic
           [optional]="true"
           [control]="webpageIndividualizationForm.get('event.guidelineHeadline')"
           [placeholder]="flTranslations.i18nGuidelinesHeadline"
           [label]="flTranslations.i18nGuidelinesHeadline">
      </div>
      <div app-form-field-rich-text
           [optional]="true"
           [control]="webpageIndividualizationForm.get('event.guidelineText')"
           [label]="flTranslations.i18nGuidelines"
           [placeholder]="flTranslations.i18nGuidelines">
      </div>
    </form>

  </div>
</aside>

<div class="esf-main-sidebar--working-space__actions -has-transition -extra-width"
     [ngClass]="{'-is-open': tixxSelectOverviewService.listOfModals.editWebpageIndividualizationModalOpened}">
  <app-submit-row-buttons [form]="'webpageIndividualizationForm'"
                          [cancelButtonText]="buttonsTranslations.i18nBack"
                          [submitButtonText]="buttonsTranslations.i18nSubmit"
                          [spinnerName]="spinnerName"
                          (cancelButton)="tixxSelectOverviewService.toggleAllModal(false)">
  </app-submit-row-buttons>
</div>

<div class="esf-hamburger esf-hamburger--working-space -has-transition"
     [ngClass]="{'-is-open': tixxSelectOverviewService.listOfModals.editWebpageIndividualizationModalOpened }" (click)="tixxSelectOverviewService.toggleAllModal(false)">
  <span class="esf-hamburger__icon"></span>
</div>
